module.exports = __webpack_public_path__ + "images/stripe-icon.ab474e0b6f35e54552b15945b4b4b5f7.svg";